module.exports = __webpack_public_path__ + "1053b1621ca1e28e20ace6c02fc3fbcf.pdf";